import styled from 'styled-components';
import { Grid } from '@simplywallst/ui-core';
import { media } from '@simplywallst/ui-core';

export const SubSectionHeader = styled('h3')`
  ${({ theme }) => theme.typography.baseStrong}
  color: ${(props) => props.theme.color.whiteRGBA(0.5)};
  margin: 0 0 ${({ theme }) => theme.x1spacePx}px;

  ${media.lgUp`
    color: ${(props) => props.theme.color.white};
  `}
`;
export const HeaderGrid = styled(Grid)`
  ${SubSectionHeader} {
    margin: 0;
  }
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
`;

export const Space = styled.div`
  margin-top: ${({ theme }) => theme.x2spacePx}px;
`;

export const PillWrapper = styled.div`
  margin-top: -2px;
`;
